import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d9b1268c&scoped=true"
import script from "./input.js?vue&type=script&lang=js&external"
export * from "./input.js?vue&type=script&lang=js&external"
import style0 from "./styles.scss?vue&type=style&index=0&id=d9b1268c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b1268c",
  null
  
)

export default component.exports